import { Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AuthService } from "../../../../core/service/auth.service";
import { RegisterModal } from '../register-modal/register-modal';

@Component({
  selector: "app-footer",
  templateUrl: './footer.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class FooterComponent {
  loggedIn = false;
  private auth = inject(AuthService);
  private bottomSheet = inject(MatBottomSheet);
  constructor(private router: Router) {}

  ngOnInit(): void {
    const currentUser = this.auth.currentUser();
    // Aquí podrías verificar el estado de autenticación real, por ejemplo, consultando un servicio de autenticación
    this.loggedIn = !currentUser; // Ejemplo simple usando localStorage
  }

  goToRegister(): void {
    this.bottomSheet.open(RegisterModal, {
      disableClose: false,
      hasBackdrop: true,
      panelClass: 'register-modal-bottom-sheet',
    });
  }

  goToOwner(): void {
    this.router.navigate(['/owner']);
  }
}
